import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  CapturePostHogEventProps,
  PostHogPageName,
  capturePostHogEvent,
} from '~/store/actions/posthogActions';

const withPostHogPageVisit = (
  WrappedComponent: React.FC<unknown>,
  captureEventProps?: CapturePostHogEventProps
) => {
  const ComponentPageVisit: React.FC = (props) => {
    const dispatch = useDispatch();
    const displayName = WrappedComponent.displayName ?? WrappedComponent.name;
    useEffect(() => {
      dispatch(
        capturePostHogEvent({
          ...captureEventProps,
          product: PostHogPageName.DASHBOARD,
          eventName: `visit_${displayName}`,
        })
      );
    }, []);
    return <WrappedComponent {...props} />;
  };

  return ComponentPageVisit;
};

export default withPostHogPageVisit;
